import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class MessageService extends BaseService {

    static url = "messages";
    static apis = {
       
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("messages");
    }

}

export default MessageService;